import React from 'react';
import { Table } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { addCount, sortName } from "./store.js"; 

function Cart(){

    let state = useSelector((state) => state) 
    // console.log(state.cart[0].name);
    // dispatch는 store.js 로 요청보내주는 함수
    let dispatch = useDispatch() //4. useDispatch() import하고 사용

    return(
      <>
        <Table>
          <thead>
              <tr>
                  <th>#</th>
                  <th>상품명</th>
                  <th>수량</th>
                  <th>변경하기</th>
              </tr>
          </thead>
          <tbody>
  
              {
                  state.cart.map((v, i) =>
                      <tr key={i}>
                          <td>{state.cart[i].id}</td>
                          <td>{state.cart[i].name}</td>
                          <td>{state.cart[i].count}</td>
                          <td><button onClick={()=>
                            dispatch(addCount(state.cart[i].id))
                          }>+</button></td>
                      </tr>
                  )
              }                                      
  
          </tbody>
        </Table>
        <button variant="outline-primary" onClick={()=>{
          dispatch(sortName(state.cart.Name))
        }}>이름순정렬</button>{' '}
      </>
    )
    };
  export default Cart
